<template>
    <div @mousedown="mouseDown">
        <header style="position: relative;"><p>{{ title }}</p><div class="x" @click="$emit('exit','x')"></div></header>
    </div>
</template>

<script>

export default {
    props: [ 'title' ],
    beforeDestroy () {
        console.log('mHeader destroy')
        this.mouseUp();
    },
    data () {
        return {
            startX: 0,
            startY: 0,
            x: 0,
            y: 0,
            parent: false
        }
    },
    mounted () {
        this.parent = this.$el.parentElement;
        var current = getComputedStyle(this.parent);
        this.top = parseInt(current.top);
        this.left = parseInt(current.left);
    },
    methods: {
        mouseUp ( e ) {
            document.body.removeEventListener('mouseup',this.mouseUp);
            document.body.removeEventListener('mousemove',this.mouseMove);
        },
        mouseMove ( e ) {
            this.x = e.clientX - this.startX;
            this.y = e.clientY - this.startY;
            this.parent.style.transform = 'translate('+this.x+'px,'+this.y+'px)'
        },
        mouseDown ( e ) {
            this.startX = e.clientX - this.x;
            this.startY = e.clientY - this.y;
            document.body.addEventListener('mouseup',this.mouseUp);
            document.body.addEventListener('mousemove',this.mouseMove);
        }
    }
}

</script>

<style lang="scss">
header {
    border-bottom: 1px solid #c0c0c0;
    p {
        font-size: 18px;
        padding: 8px;
    }
}
div.x { position: absolute; right: -3px; top: 0px; width: 42px; height: 42px; }
div.x:before,div.x:after { content: ''; width: 40px; height: 2px; background-color: rgba(0,0,0,0.4); position: absolute; top: 18px; }
div.x:before { transform: rotate(45deg); }
div.x:after { transform: rotate(-45deg); }

</style>